export const planStatusConstants = {
  ID: 'id',

  NAME: 'name',
  NAME_LABEL: 'Name',

  ORDER: 'order',
  ORDER_LABEL: 'Order',
};
